module.exports = __webpack_public_path__ + "media/St 4-washer dryer-question.5d0c67f1.wav";